import { useTranslate } from '../../../../../common/hooks/useTranslate';

function useHttpCodeToStatusText(code: number) {
  const { t } = useTranslate();

  switch (code) {
    case 401:
      return {
        errorText: t('httpErrors.code401errorText'),
        statusText: t('httpErrors.code401statusTextText')
      };
    case 403:
      return {
        errorText: t('httpErrors.code403errorText'),
        statusText: t('httpErrors.code403statusTextText')
      };
    case 404:
      return {
        errorText: t('httpErrors.code404errorText'),
        statusText: t('httpErrors.code404statusTextText')
      };
    case 500:
      return {
        errorText: t('httpErrors.code500errorText'),
        statusText: t('httpErrors.code500statusTextText')
      };
    default:
      return {
        errorText: t('httpErrors.code500errorText'),
        statusText: t('httpErrors.code500statusTextText')
      };
  }
}

export default useHttpCodeToStatusText;
